import React, { useState, useEffect } from 'react';
import backgroundImage from '../../../assets/background.jpg';
import './Layout.css';

const Layout = ({ children }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = backgroundImage;
        img.onload = () => setImageLoaded(true);
    }, []);

    return (
        <div className="app-layout">
            <div
                className="background-container"
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    opacity: imageLoaded ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out'
                }}
            >
            </div>
            {children}
        </div>
    );
};

export default Layout;